import styled from 'styled-components';

export const Section = styled.section`
  margin: 0 ${({ theme }) => theme.spacing.ms} ${({ theme }) => theme.spacing.sm};
`;

export const Title = styled.h2`
  margin: 0 0 ${({ theme }) => theme.spacing.ms};
  font-size: ${({ theme }) => theme.typography.fontSize.xl};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: center;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.ms};
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  box-shadow: ${({ theme }) => theme.shadows.md};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  /* 幅の狭い端末では日付が次の行に折り返るようにする */
  flex-wrap: wrap;
`;

export const LabelGroup = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
`;

export const Label = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: nowrap;
`;

export const DateValue = styled.span`
  display: flex;
  align-items: baseline;
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

/* 年月日の数字は読み取りやすさを優先して単位より一段大きくする */
export const DateNumber = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.xxl};
`;

export const DateUnit = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.xl};
`;

export const Note = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.light};
  color: ${({ theme }) => theme.colors.text.secondary};
`;
